/**
 * client.js — tiny JWT-aware fetch wrapper for the auth/billing API.
 * The JWT lives in localStorage under `qr_token`.
 */
import { AUTH_API_URL } from '../config';
import { reportUserRateLimited } from '../utils/dataGate';

const TOKEN_KEY = 'qr_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); };

export async function api(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (auth && token) headers.Authorization = `Bearer ${token}`;

  const resp = await fetch(`${AUTH_API_URL}${path}`, {
    method,
    headers,
    body: body != null ? JSON.stringify(body) : undefined,
  });
  if (resp.status === 429) {
    const retryAfter = parseInt(resp.headers.get('retry-after') || '0', 10);
    reportUserRateLimited(retryAfter > 0 ? retryAfter * 1000 : 30_000);
  }
  const data = await resp.json().catch(() => null);
  if (!resp.ok) {
    const err = new Error((data && (data.message || data.error)) || `HTTP ${resp.status}`);
    err.status = resp.status;
    err.payload = data;
    throw err;
  }
  return data;
}
